import React, { useState, useRef } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import FiltersPartial from "./FiltersPartial.js";
import Page from "../Page.js";
import ListingComponent from "../../components/ListingComponent.js";
import {
  updateQueryParams,
} from "../../ui/customerListingReducer";
import { useDispatch } from "react-redux";

const Index = () => {
  const [filtersModel, setFiltersModel] = useState({})
  const [params, setParams] = useState({})
  const defaultHeaderConfig = { disableSort: false };
  const userIdRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const dispatch = useDispatch();
  const [idError, setIdError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Transaction For',
      attr: 'transaction_for',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Remarks',
      attr: 'remarks',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Transaction Type',
      attr: 'transaction_type',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
    },
  ]

  const changeFilterModelForId = (e) => {
    e.preventDefault();
    if(e.target.id.value === ""){
      setMobileError("");
      setIdError("This field cannot be blank !");
    } else {
      setIdError("");
      setMobileError("");
      mobileNumberRef.current.value = "";
    }
    setParams({ user_id: e.target.id.value });
    dispatch(updateQueryParams({ user_id: e.target.id.value }));
  }

  const changeFilterModelForMobileNumber = (e) => {
    e.preventDefault();
    if(e.target.mobile_number.value === ""){
      setIdError("");
      setMobileError("This field cannot be blank !");
    } else {
      setMobileError("");
      setIdError("");
      userIdRef.current.value = "";
    }
    setParams({ mobile_number: e.target.mobile_number.value });
    dispatch(updateQueryParams({ mobile_number: e.target.mobile_number.value }));
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.WalletTransactionsListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Wallet Transactions'}]}
    className={'wallet-transactions-page'}
  >
    <div className="d-flex justify-content-start">
      <form style={{paddingRight: "120px"}} onSubmit={changeFilterModelForId}>
        <label className="form-label form-label-sm mb-1" htmlFor="id">Search By User Id</label>
        <input
          id="id"
          className="form-control form-control-sm font-size-12"
          placeholder="User Id"
          type="text"
          ref={userIdRef}
        />
        <div id="id_help" className="form-text text-danger">
          {idError}
        </div>
        <input className="s-btn my-2 font-size-11" style={{ width: "80px" }} type="submit" />
      </form>

      <form onSubmit={changeFilterModelForMobileNumber}>
        <label className="form-label form-label-sm mb-1" htmlFor="mobile_number">Search By Mobile Number </label>
        <input
          id="mobile_number"
          className="form-control form-control-sm font-size-12"
          placeholder="Mobile Number"
          type="text"
          ref={mobileNumberRef}
        />
        <div id="mobile_help" className="form-text text-danger">
          {mobileError}
        </div>
        <input className="s-btn my-2 font-size-11" style={{ width: "80px" }} type="submit" />
      </form>
    </div>
    <ListingComponent
      key={"PAGES.WalletTransactionsListingPage.name"}
      listingMutation={getApi('walletTransactions')}
      className="wallet-transactions-listing-page"
      contentHeading="Wallet Transactions for User"
      headers={headers}
      recordsKey="wallet_transactions"
      params={params}
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
      searchBy={['ID']}
    />
  </Page>
};

export default Index;
